



























































































































import {Component, Inject, Vue} from 'vue-property-decorator';
import {BaseLink} from '@/core/standard/BaseLink';
import AuthServices from '@/modules/auth/AuthServices';
import GlobalSettingServices from '@/modules/settings/global/GlobalSettingServices';
import {ILink} from '@/setup/router/links';
import {IGlobals} from '@/modules/settings/global/IGlobalSettingsModel';
import TPVServices from '@/modules/auth/TPVServices';
import LocalsServices from '@/modules/auth/LocalsServices';
import {IKitchenTickets} from '@/modules/settings/kitchen-ticket/IKitchenTicketSettingsModel';
import {IGlobalConfigs} from '@/setup/GlobalConfigs/IGlobalConfigs';
import {loadLanguageAsync} from '@/setup/lang';
import {IDomicilePickups} from '@/modules/settings/domicile_pickup/IDomicilePickupSettingsModel';
import {IBookings} from '@/modules/settings/booking/IBookingSettingModel';
import {IUnits} from '@/modules/units/IUnitModel';
import { i18n } from '@/plugins/i18n';

@Component({name: 'Login'})
export default class Login extends Vue {
  modules: string[] = [];
// Props
  @Inject({from: Symbol.for('Links')}) links!: ILink[];
  @Inject({from: Symbol.for('GlobalSetting')}) GlobalSettings!: { new(): IGlobals };
  @Inject({from: Symbol.for('KitchenTicketSetting')}) KitchenSettings!: { new(): IKitchenTickets };
  @Inject({from: Symbol.for('DomicilePickupSetting')}) DomicilePickupSettings!: { new(): IDomicilePickups };
  @Inject({from: Symbol.for('GlobalConfigs')}) GlobalConfigs!: IGlobalConfigs;
  @Inject({from: Symbol.for('BookingSetting')}) BookingSettings!: { new(): IBookings };
  @Inject({from: Symbol.for('Unit')}) Unit!: { new(): IUnits };

// Data
  formValidator: boolean = false;
  resetFormValidation: boolean = false;
  email: string = '';
  resetPasswordEmail: string = '';
  resetPasswordLoading: boolean = false;
  language: string = navigator.language.split('-')[0] || 'en';
  password: string = '';
  tpv: Record<string, string> = {} as Record<string, string>;
  tpvList: Record<string, any>[] = [];
  rules: any = {
    email: [
      (v) => !!v || 'Correo Requerido',
      (v) => /.+@.+\..+/.test(v) || 'Debe ser un correo válido',
    ],
    password: [
      (v) => !!v || 'Contraseña Requerida',
      (v) => v.length >= 3 || 'Contraseña debe ser de mas de 2 caracteres',
    ], tpv: [
      (v) => !!v || 'TPV Requerido',
    ],
  };
  globalSettingsModel: IGlobals = {} as IGlobals;
  kitchenTicketSettingsModel: IKitchenTickets = {} as IKitchenTickets;
  domicilePickupSettingsModel: IDomicilePickups = {} as IDomicilePickups;
  bookingSettingsModel: IBookings = {} as IBookings;
  unitModel: IUnits = {} as IUnits;
  resetPasswordDialog: boolean = false;

// Hooks
  async beforeRouteLeave(to, from, next) {
    const request = await LocalsServices.getLocales({query: JSON.stringify({location: location.origin})});
    if (request.data) {
      const modules = request.data.modules.split(',');
      this.modules.push(...modules);
      localStorage.setItem('modules', JSON.stringify(this.modules));
      localStorage.setItem('localToken', request.data.websocket);
    }
    this.links.forEach((link) => {
      BaseLink.setLinkPermissionsRecursive(link, [...this.modules]);
    });
    next();
  }

  created() {
    if ('e' in this.$route.params) {
      const error = JSON.parse(atob(this.$route.params.e));
      Object.keys(error.message).forEach((errorKey: any) => {
        this.$toast.error(error.message[errorKey]);
      });
    }
  }

  async mounted() {

    if (localStorage.getItem('globalData')) {
      localStorage.removeItem('globalData');
    }
    if (localStorage.getItem('userRole')) {
      localStorage.removeItem('userRole');
    }
    if (localStorage.getItem('group_type')) {
      localStorage.removeItem('group_type');
    }
    if (localStorage.getItem('tpv')) {
      localStorage.removeItem('tpv');
    }
    if (localStorage.getItem('token')) {
      localStorage.removeItem('token');
    }
    if (localStorage.getItem('modules')) {
      localStorage.removeItem('modules');
    }
    if (localStorage.getItem('tpvIds')) {
      localStorage.removeItem('tpvIds');
    }

    BaseLink.clean(this.links);
    if (this.$route.query.redirect) {
      this.$toast.error('Debes logearte primero');
    }
    const [lang, tpvs] = await Promise.all([
      GlobalSettingServices.getLang({method: 'get', url: 'language'}),
      TPVServices.list()]);
    if (lang.data.language) {
      this.language = lang.data.language;
    }
    if (tpvs.complete) {
      this.tpvList = tpvs.data.results;
      if (tpvs.data.results.length) {
        this.tpv = this.tpvList[0];
      }
    }
    localStorage.setItem('lang', this.language);
    await this.changeLang(this.language);
  }

  // Methods
  async updateKeyboardSetting() {
    this.GlobalConfigs.use_touch_keyboard = !this.GlobalConfigs.use_touch_keyboard
    const fd = new FormData();
    //@ts-ignore
    fd.append('use_touch_keyboard', this.GlobalConfigs.use_touch_keyboard)
    await GlobalSettingServices.updateKeyboardSetting({
      query: fd
    })
  }

  async changeLang(lang) {
    await loadLanguageAsync(lang);
  }

  async resetPassword() {
    if (this.resetFormValidation) {
      this.resetPasswordLoading = true;
      const resp = await AuthServices.resetPassword({
        method: 'POST',
        query: { email: this.resetPasswordEmail },
      })
      this.resetPasswordLoading = false;
      if(resp.complete) {
        this.resetPasswordDialog = false
        this.resetPasswordEmail = ''
        this.$toast.success(`${i18n.t('globals.resetPasswordSent')}`);
      }else {
        this.$toast.error(`${i18n.t('globals.userNotFound')}`);
      }
    }
  }

  async login() {
    if (this.formValidator) {
      const data = {
        email: this.email,
        password: this.password,
        from_client: 'web',
        tpv: this.tpv.key,
      };
      const request = await AuthServices.login(JSON.stringify(data), this.$toast);
      if (request.complete) {
        const token = 'Bearer ' + request.token;
        localStorage.setItem('userRole', request.role || 'SuperAdmin');
        localStorage.setItem('token', token);
        localStorage.setItem('loggedUser', JSON.stringify({
          name: this.email,
          id: request.user_id
        }));
        localStorage.setItem('tpv', this.tpv.key);
        localStorage.setItem('tpvId', this.tpv.id);
        localStorage.setItem('group_type', JSON.stringify(request.group_type.length ? request.group_type : ['SuperAdmin']));
        localStorage.setItem('printerUser', JSON.stringify(request.user_id));
        localStorage.setItem('local', request.local_id);
        if(request.condominium) {
          localStorage.setItem('condominium', request.condominium);
        } 
        this.modules.push(...request.modules);
        this.globalSettingsModel = new this.GlobalSettings();
        this.kitchenTicketSettingsModel = new this.KitchenSettings();
        this.domicilePickupSettingsModel = new this.DomicilePickupSettings();
        this.bookingSettingsModel = new this.BookingSettings();
        const [global, kitchen, domicilePickup, booking] = await Promise.all([
          this.globalSettingsModel.get({}, this.$toast),
          this.kitchenTicketSettingsModel.get({}),
          this.domicilePickupSettingsModel.get({}),
          this.bookingSettingsModel.get({}),
        ]);
        Object.keys(this.GlobalConfigs).forEach(key => {
          this.GlobalConfigs[key] = booking[key] ?? global[key] ?? kitchen[key] ?? domicilePickup[key];
        });
        const tpvIds: Record<any, any>[] = [];
        this.tpvList.forEach((tpv) => {
          tpvIds.push(tpv);
        });
        localStorage.setItem('tpvIds', JSON.stringify(tpvIds));
        return this.$router.push({name: 'table_requests'});
      }
    }

    (this.$refs.form as any).validate();
  }
}
